/**
 * Liste des ingrédients sélectionnés (chips avec bouton retirer)
 */

import React from "react";
import { HiOutlineXMark } from "react-icons/hi2";

export default function SelectedIngredientsSection({
  availableIngredients,
  setAvailableIngredients,
  removeIngredient,
  getIngredientLabel,
  t,
}) {
  if (availableIngredients.length === 0) return null;

  return (
    <div className="pt-4 border-t border-white/15">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-medium text-white">
          {t("selectedIngredients")} ({availableIngredients.length})
        </span>
        <button
          type="button"
          onClick={() => setAvailableIngredients([])}
          className="text-xs text-red-300 hover:text-red-200 font-medium transition-colors"
        >
          {t("clearAll")}
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {availableIngredients.map((ingredient) => (
          <span
            key={ingredient}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/15 rounded-lg text-sm text-white border border-white/20"
          >
            {getIngredientLabel(ingredient)}
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                removeIngredient(ingredient);
              }}
              className="p-0.5 rounded hover:bg-white/20 text-white/80 hover:text-white transition-colors"
              aria-label="Retirer"
            >
              <HiOutlineXMark className="w-4 h-4" />
            </button>
          </span>
        ))}
      </div>
    </div>
  );
}
